// extracted by mini-css-extract-plugin
export default {"btnBackground":"Home_btnBackground__qqfDo","btnMargin":"Home_btnMargin__ElYdl","icons":"Home_icons__4dcR5"};